/**
* Use this file for JavaScript code that you want to run in the front-end
* on posts/pages that contain this block.
*
* When this file is defined as the value of the `viewScript` property
* in `block.json` it will be enqueued on the front end of the site.
*
* Example:
*
* ```js
* {
*   "viewScript": "file:./view.js"
* }
* ```
*
* If you're not making any changes to this file because your project doesn't need any
* JavaScript running in the front-end, then you should delete this file and remove
* the `viewScript` property from `block.json`.
*
* @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
*/







var openTab = function(tabid) {

  //console.log ("click "+tabid);

  const current_tab_title =  document.querySelector("[data-tab-target='"+tabid+"']");

  const current_tab =  document.querySelector("[data-tab='"+tabid+"']");
  const tab_parent_container = current_tab.closest('.wp-block-ma-blocks-ma-tabs');

  const tabs = tab_parent_container.querySelectorAll('.wp-block-ma-blocks-ma-tab');
  tabs.forEach(function(tab, index){
    tab.classList.remove("open");             // Remove active
    tab.removeAttribute('data-tab-open');
  });


  const tab_titles = tab_parent_container.querySelectorAll('.ma-title-item');
  tab_titles.forEach(function(tab_title, index){
    tab_title.classList.remove("active");             // Remove active
  });

  current_tab.classList.add("open");
  current_tab.setAttribute('data-tab-open', true);
  current_tab_title.classList.add("active");
}







const matabblocks = document.querySelectorAll(".wp-block-ma-blocks-ma-tabs");


matabblocks.forEach(function(matabblock){

//  console.log(matabblock);

  const current_id = matabblock.getAttribute('data-opened-tab');
  const tab_titles = matabblock.querySelectorAll(".ma-title-item") ;
  


/*  if (matabblock.getAttribute("data-opened-tab") !== null) {
    openTab(matabblock.getAttribute("data-opened-tab"));
  }*/


  tab_titles.forEach(function(tab_title){

    const tab_id = tab_title.getAttribute('data-tab-target');
    //console.log(tab_title);
    //console.log('tab_id' +tab_id);
    tab_title.addEventListener("click",  function(){  openTab(tab_id)  },  false);

  });







});
